<template>
  <modal width="35" title="Process Handoff" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div class="flex my-4 flex-col gap-2 justify-center">
      <!-- <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">Shipping Ref:</div>
        <div><input class="input" disabled :value="dispatch && dispatch.dispatchReference" /></div>
      </div> -->

      <!-- <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">Booking Date:</div>
        <div><el-date-picker disabled type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
            v-model="dispatch.createdAt" /></div>
      </div> -->

      <!-- <div class="flex flex-col gap-2 w-full">
        <div class="font-semibold">Delivery Date:</div>
        <div><el-date-picker disabled type="date" placeholder="Delivery Date" style="margin: 0" class="mr-3"
            v-model="deliveryDate" /></div>
      </div> -->
      <!-- <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">Delivery Status</div>
        <div>
          <el-select v-model="reason" placeholder="-- Select or Input --">
            <el-option label="In good condition" value="In good condition"> </el-option>
            <el-option label="Damaged" value="Damaged"> </el-option>
            <el-option label="Others" value="others"> </el-option>
          </el-select>
        </div>
      </div> -->
      <!-- <hr class="my-2" />   -->
      <p class="font-bold">Handoff process for:</p> 
      <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">3pl Company:</div>
        
        <div>
          <el-select disabled filterable v-model="toOrgName" placeholder="3pl Company">
            <!-- <el-option  :label="toOrgName">
              </el-option> -->
          </el-select>
        </div>
      </div>
      <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">Terminal:</div>
        <div>
          <el-select filterable @change="getUserObj" v-model="toUserId" placeholder="Individual/Organization">
            <el-option v-for="kind in users" :key="kind.id" :label="kind.firstname + ' ' + kind.lastname"
              :value="kind.id"></el-option>
          </el-select>
        </div>
      </div>
       <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">3pl User:</div>
        <div>
          <el-select filterable @change="getUserObj" v-model="toUserId" placeholder="Individual/Organization">
            <el-option v-for="kind in users" :key="kind.id" :label="kind.firstname + ' ' + kind.lastname"
              :value="kind.id"></el-option>
          </el-select>
        </div>
      </div>

      <div class="flex justify-end w-100">
        <base-button text="Request Handoff Receipt"
          @click="$emit('show-confirm-handoff', processObj); $emit('close-modal');" :loading="loading" />
      </div>
    </div>

  </modal>
</template>

<script>
export default {
  components: {
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    dispatch: {
      type: Object,
      default: () => ({})
    }
    // dispatch: {
    //    type: Object,
    //    required: true
    // }
  },
  data() {
    return {
      reason: "",
      loading: false,
      organizations: [],
      users: [],
      toUserId: "",
      toOrgId: "",
      toOrgName: "",
      userObj: {},
      locationObj: {},
      orgReceiver: {},
      deliveryDate: new Date()
    };
  },
  watch: {
    toOrgId(val) {
      this.getAllUsers(val);
    },
  },
  computed: {
    orgid() {
      return this.$store.state.authentication.quantumOrganizationId;
    },
    userid() {
      return this.$store.state.authentication.quantumUserId;
    },
    processObj() {
      return {
        fromOrgid: this.$store.state.authentication.organizationId,
        toOrgId: this.toOrgId,
        fromUserId: this.$store.state.authentication.userId,
        toUserId: this.toUserId,
        dispatch: this.dispatch,
        userObj: this.userObj,
        locationObj: this.locationObj,
        orgReceiver: this.orgReceiver,
        reason: this.reason
      }
    },
  },
  methods: {
    getAllUsers(orgid) {
      try {

        let users = this.organizations.find(x => x.id == orgid).users.filter(x => x.id != this.$store.state.authentication.userId)

        this.users = users
        this.loading = false;
        localStorage.setItem("users", JSON.stringify(this.users));
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async getOrganizations() {
      try {
        this.loading = true;
        const response = await this.$_organizations();
        let organizations = response.data.data;

        this.organizations = organizations

        let destinationOrg = organizations.find(x => x.id == this.dispatch.orgId)

        console.log(destinationOrg)
        this.toOrgName = destinationOrg.companyname
        this.toOrgId = destinationOrg.id

        this.getAllUsers(destinationOrg.id)

        this.loading = false;
        this.$emit("dispatch-subaction-completed");

        this.closeModal();
      } catch (error) {
        this.loading = false;
        this.handleError(error);
        this.loading = false;
      }
    },
    getUserObj() {
      // let userObj = this.users.find(x => x.id = this.toUserId);
      let orgReciever = this.organizations.find(x => x.id == this.toOrgId)
      // let locationObj = this.organizations.find(x => x.id == this.toOrgId).locations.find(x => x.locationManager == this.toUserId)

      this.orgReceiver = {
        companyname: orgReciever.companyname,
        mobile_no: orgReciever.mobile_no,
      }
      this.getUser()

      // console.log(userObj)

      // this.userObj = {
      //     firstname : userObj.firstname,
      //     lastname : userObj.lastname,
      //     mobile_no : userObj.mobile_no,
      //     email : userObj.email,
      //     address: userObj.address

      // }

      // this.locationObj = {
      //     locationName : locationObj.locationName,
      //     address : locationObj.address,
      //     state : locationObj.state,
      //     country : locationObj.country
      // }
    },
    async getUser() {
      try {
        const response = await this.$_getSingleUser(this.toUserId)

        this.userObj = response.data.user
        console.log(response.data.user)
      } catch (error) {
        this.handleError(error);
      }
    },


    closeModal() {
      this.$emit("close-modal");
    },
  },
  mounted() {
    this.getOrganizations();
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
</style>